import { render } from "./CheckboxgroupCheckbox_tabs.vue?vue&type=template&id=c7b02150"
import script from "./CheckboxgroupCheckbox_tabs.vue?vue&type=script&lang=js"
export * from "./CheckboxgroupCheckbox_tabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__